import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JwtComponent } from './components/jwt/jwt.component';
import { TokenHasExpiredComponent } from './components/token-has-expired/token-has-expired.component';
import { NotificationCarouselComponent } from './components/notification-carousel/notification-carousel.component';
import { MainLoadingComponent } from './components/main-loading/main-loading.component';
import { IconsModule } from '../icons/icons.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChatComponent } from './components/chat/chat.component';
import { ChatHistoryModalComponent } from './components/chat/chat-history-modal/chat-history-modal.component';
import { ChatSoporteComponent } from './components/chat-soporte/chat-soporte.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';

@NgModule({
    declarations: [
        JwtComponent,
        TokenHasExpiredComponent,
        NotificationCarouselComponent,
        MainLoadingComponent,
        ChatComponent,
        ChatHistoryModalComponent,
        ChatSoporteComponent
    ],
    exports: [
        JwtComponent,
        TokenHasExpiredComponent,
        NotificationCarouselComponent,
        MainLoadingComponent,
        ChatComponent,
        ChatSoporteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IconsModule,
        NgbModule,
        NgOptimizedImage,
        MatButtonModule,
        MatIconModule,
        MatDividerModule
    ]
})
export class CoreModule { }
